import React, { Component } from 'react';
import '../assets/css/reset.css'
import '../assets/css/App.css'
import Header from './Header';
import Footer from './Footer';
import { withRouter } from 'react-router-dom'

class Logout extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    localStorage.clear()
  }

  render() {
    return (
      <div className="App">
        <Header />
        <div className="main-content">
          <div className="ccpa-wrapper">
            <div className="component-section">
              <div className="max-width-20 position-center margin-center">
                <p className="timeout">You have sucessfully logged out!</p>
                <p className="margin-top-2 margin-bottom-2"> Please click on View Request button in the email to login again.</p>
              </div>
            </div>
          </div>
        </div> 
         <Footer/>
      </div>
    );
  }
}

export default withRouter(Logout);



// WEBPACK FOOTER //
// src/components/Logout.js